

export const logoApplication = "https://res.cloudinary.com/dsgd2h3dx/image/upload/v1760000287/Es_sce_que_tu_peux_faire_de_tel_sorte_que_je_veux_logo_soi_informaituque_pour_un_iste_ecommerce_s_il_te_plais._je_veux_g%C3%A9nrer_pour_l_itiliser_sur_mon_site_ecommerce_de_prefrece_il_dois_y_avoir_du_rouge_s_il_te_4_ggpxyu.jpg";

export const profileRoleType = {
  CUSTOMER: "CUSTOMER",
  USER: "USER",
  //adminstrator
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  SUPPORT: "SUPPORT",
}




export  const responsivePublication = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 40
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 30
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1,
      partialVisibilityGutter: 20
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 10
    }
  };

